import React, { memo } from 'react';
import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles({
  icon: {
    width: '0.375rem',
    height: '1.5rem',
  },
});

const DotsOptionsIcon = () => {
  const classes = useStyles();

  return (
    <SvgIcon width="6" height="24" viewBox="0 0 6 24" className={classes.icon}>
      <circle cx="3" cy="3" r="3" fill="white" />
      <circle cx="3" cy="12" r="3" fill="white" />
      <circle cx="3" cy="21" r="3" fill="white" />
    </SvgIcon>
  );
};

export default memo(DotsOptionsIcon);
